import { useEffect, useState } from "react";
import { Headphones } from "lucide-react";
import { api } from "@/lib/api";
import { PodcastPlayer } from "@/components/podcast/PodcastPlayer";
import { PodcastSubmitDialog } from "@/components/podcast/PodcastSubmitDialog";
import { SectionTitle } from "@/components/news/SectionTitle";

export default function PodcastPage() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/podcasts").then((r) => setItems(r.data)); }, []);

  return (
    <div className="space-y-8" data-testid="podcast-page">
      <div className="bg-[#111827] text-white p-8 md:p-12 flex flex-col md:flex-row md:items-end justify-between gap-6 relative overflow-hidden">
        <Headphones size={160} className="absolute -right-6 -bottom-10 text-red-600/20" />
        <div className="relative">
          <span className="badge-cat">Audio</span>
          <h1 className="font-heading text-4xl sm:text-5xl font-black mt-3">Podcast Chronique.cd</h1>
          <p className="text-zinc-400 mt-3 max-w-xl">Débats, reportages et chroniques sonores sur l'actualité congolaise. Écoutez nos émissions ou déposez votre propre audio.</p>
        </div>
        <div className="relative"><PodcastSubmitDialog /></div>
      </div>
      <div data-testid="podcast-player">
        <SectionTitle>Tous les épisodes <span className="text-zinc-400 font-normal normal-case text-sm ml-2">{items.length} épisode{items.length > 1 ? "s" : ""}</span></SectionTitle>
        <div className="grid gap-4">{items.map((p, i) => <PodcastPlayer key={p.id} podcast={p} testId={`podcast-${i}`} />)}</div>
        {!items.length && <p className="text-zinc-500 py-10 text-center bg-white border">Aucun épisode pour le moment.</p>}
      </div>
    </div>
  );
}
